var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('common-tabs',{attrs:{"items":_vm.items},model:{value:(_vm.itemId),callback:function ($$v) {_vm.itemId=$$v},expression:"itemId"}})}
var staticRenderFns = []

export { render, staticRenderFns }